// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'dark_theme',
    themes: {
      dark_theme: {
        dark: true,
        variables: {},
        colors: {
          primary: "#171717",
          //background: "#0d0d0d",
          litletext: "#7affc7",
          textcolor: "#07f490",
          titlecolor: "#dcdcdc"
        },
      },
      light_theme: {
        light: true,
        variables: {},
        colors: {
          primary: "#edeeef",
          background: "#1C1B22",
          litletext: "#3c546d",
          textcolor: "#0478f4"
        },
      },
    },
  },
})
